import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = JSON.parse(localStorage.getItem('user'));
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('shopProfile');
    localStorage.removeItem('priceCodeSettings');
    navigate('/');
  };

  const isActive = (path) => location.pathname === path;

  return (
    <nav style={styles.nav}>
<div style={styles.brand}>
  <img src="/logo.png" alt="Wahi POS" style={{ height: '32px', marginRight: '8px', verticalAlign: 'middle' }} />
  Wahi POS
</div>      
<div style={styles.links}>
        <Link to="/dashboard" style={isActive('/dashboard') ? styles.linkActive : styles.link}>Dashboard</Link>
        <Link to="/products" style={isActive('/products') ? styles.linkActive : styles.link}>Products</Link>
        <Link to="/suppliers" style={isActive('/suppliers') ? styles.linkActive : styles.link}>Suppliers</Link>
        <Link to="/invoices" style={isActive('/invoices') ? styles.linkActive : styles.link}>Invoices</Link>
        <Link to="/invoices/create" style={isActive('/invoices/create') ? styles.linkActive : styles.link}>New Invoice</Link>
        <Link to="/customers" style={isActive('/customers') ? styles.linkActive : styles.link}>Customers</Link>
        <Link to="/expenses" style={isActive('/expenses') ? styles.linkActive : styles.link}>Expenses</Link>
        <Link to="/reports" style={isActive('/reports') ? styles.linkActive : styles.link}>Reports</Link>
        <Link to="/hr" style={isActive('/hr') ? styles.linkActive : styles.link}>HR</Link>
      </div>
      <div style={styles.right}>
  
  <Link to="/profile" style={styles.profileLink}>{user?.shop_name}</Link>
  <button onClick={handleLogout} style={styles.logout}>Logout</button>
</div>
    </nav>
  );
};

const styles = {
  nav: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '1rem 2rem', background: '#4f46e5', color: '#fff', flexWrap: 'wrap', gap: '1rem' },
  brand: { fontSize: '20px', fontWeight: 'bold', color: '#fff' },
  links: { display: 'flex', gap: '1rem', flexWrap: 'wrap' },
  link: { color: '#fff', textDecoration: 'none', fontSize: '14px', opacity: 0.8 },
  linkActive: { color: '#fff', textDecoration: 'none', fontSize: '14px', fontWeight: 'bold', borderBottom: '2px solid #fff', paddingBottom: '2px' },
  right: { display: 'flex', alignItems: 'center', gap: '1rem' },
  profileLink: { fontSize: '14px', color: '#c7d2fe', textDecoration: 'none', borderBottom: '1px dashed #c7d2fe' },
  logout: { padding: '6px 14px', background: '#fff', color: '#4f46e5', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' },
  adminLink: { fontSize: '13px', color: '#fcd34d', textDecoration: 'none', fontWeight: 'bold' },
};

export default Navbar;